<template>
  <section class="careers">
    <div class="head">
      <div class="inner">
        <h1 class="title">正在寻找您的下一个挑战？</h1>
        <p class="label">
          在
          Xport，我们共同努力，通过将在线零售商和品牌与全球客户联系起来，改变电子商务的面貌。
        </p>
        <el-button type="danger" round>立即申请</el-button>
      </div>
    </div>
    <!-- <div class="team">
      <h1 class="title">认识我们的团队</h1>
      <p class="label">
        我们的员工在我们的成功中发挥着关键作用，我们一直在寻找更多有动力、有才华和雄心勃勃的人才加入我们不断壮大的国际大家庭。
      </p>
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item, index) in imgOption" :key="index"
          ><img
            @click="toVideo('')"
            @mousedown.self="startDrag"
            :src="item.url"
          />
          <div class="icon">
            <svg
              aria-hidden="true"
              class="e-font-icon-svg e-eicon-play"
              viewBox="0 0 1000 1000"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="#e7e6e6"
                d="M838 162C746 71 633 25 500 25 371 25 258 71 163 162 71 254 25 367 25 500 25 633 71 746 163 837 254 929 367 979 500 979 633 979 746 933 838 837 929 746 975 633 975 500 975 367 929 254 838 162M808 192C892 279 933 379 933 500 933 621 892 725 808 808 725 892 621 938 500 938 379 938 279 896 196 808 113 725 67 621 67 500 67 379 108 279 196 192 279 108 383 62 500 62 621 62 721 108 808 192M438 392V642L642 517 438 392Z"
              ></path>
            </svg>
          </div>
        </swiper-slide>
      </swiper>
    </div> -->
    <div class="open-position">
      <div class="inner">
        <h1 class="title">空缺职位</h1>
        <div class="list">
          <div
            v-for="item in locOption"
            :key="item.value"
            :class="[item.check ? 'check-item' : '', 'item']"
            @click="toPositions(item)"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <positions id="positions" :locValue="locValue"></positions>
    <!-- <div class="photo-wall">
      <div class="row">
        <div class="col">
          <img src="@/assets/careers/Group-32703.png">
        </div>
        <div class="col">
          <img
            src="@/assets/careers/image-4.png"
            alt=""
          >
          <p>Xport 团队由来自不同文化和不同专业背景的多元化人员组成，他们每天都带来创造力、技能和辛勤工作。
            <br><br>我们鼓励个人思考和团队合作，并创造包容性的环境，让创新理念蓬勃发展。
            <br><br>我们不断的成功完全归功于我们的员工。感谢他们的热情和承诺，我们突破界限，帮助我们的客户在全球范围内扩展他们的品牌并加速他们的增长。
          </p>
        </div>
        <div class="col">
          <img src="@/assets/careers/Group-32704.png">
        </div>
      </div>
      <div>
        <img
          src="@/assets/careers/Group-32702-1.png"
          alt=""
        >
      </div>
    </div> -->
    <way></way>
    <el-dialog :visible.sync="showDialog" width="90vw">
      <iframe
        src="https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1"
        frameborder="1"
      ></iframe>
    </el-dialog>
  </section>
</template>

<script>
import Positions from './component/positions.vue'
import Way from './component/way.vue'
export default {
  name: 'careers',
  components: {
    Positions,
    Way
  },
  data() {
    return {
      locOption: [
        {
          label: '英国， 伦敦',
          value: '1'
        },
        {
          label: '爱尔兰， 都柏林',
          value: '2'
        },
        {
          label: '美国，佐治亚州，亚特兰大',
          value: '3'
        },
        {
          label: '香港',
          value: '4'
        },
        {
          label: '韩国首尔',
          value: '5'
        },
        {
          label: '日本， 东京',
          value: '6'
        },
        {
          label: '美国， 新泽西州霍博肯',
          value: '7'
        },
        {
          label: '美国， 纽约州， NY',
          value: '8'
        },
        {
          label: '美国， 洛杉矶， CA',
          value: '9'
        },
        {
          label: '以色列， Petah Tikva',
          value: '10'
        },
        {
          label: '澳大利亚， 墨尔本',
          value: '11'
        },
        {
          label: '法国， 巴黎',
          value: '12'
        },
        {
          label: '罗马尼亚， 布加勒斯特',
          value: '13'
        },
        {
          label: '德国， 柏林',
          value: '14'
        },
        {
          label: '瑞典， 斯德哥尔摩',
          value: '15'
        }
      ],
      locValue: '',
      showDialog: false,
      videoUrl: '',
      isDragging: false,
      imgOption: [
        {
          url: require('@/assets/careers/Group-32705-1-1.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '1'
        },
        {
          url: require('@/assets/careers/Group-32716-1-1.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '2'
        },
        {
          url: require('@/assets/careers/Group-32707-1-1.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '3'
        },
        {
          url: require('@/assets/careers/Group-32706-1-1.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '4'
        },
        {
          url: require('@/assets/careers/Group-32708-1-1.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '5'
        },
        {
          url: require('@/assets/careers/Group-32709-1-1-1.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '6'
        },
        {
          url: require('@/assets/careers/Group-32710-1-1.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '7'
        },
        {
          url: require('@/assets/careers/Group-32711-1-1.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '8'
        },
        {
          url: require('@/assets/careers/Group-32712-1-1.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '9'
        },
        {
          url: require('@/assets/careers/Group-32713-1-1.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '10'
        },
        {
          url: require('@/assets/careers/Group-32714-1-1-2.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '11'
        },
        {
          url: require('@/assets/careers/Group-32715-1-2.png'),
          videoUrl:
            'https://player.vimeo.com/video/924415759?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&autoplay=1',
          value: '12'
        }
      ],
      swiperOption: {
        loop: true,
        slidesPerView: 5,
        spaceBetween: 10,
        grabCursor: true
      },
      positionTop: ''
    }
  },
  created() {},
  mounted() {
    this.positionTop = document.getElementById('positions').offsetTop
  },
  methods: {
    toPositions(e) {
      this.locOption.forEach(item => {
        item.check = item.value === e.value
      })
      this.locValue = e.value
      window.scrollTo(0, this.positionTop - 100)
      this.$forceUpdate()
    },
    toVideo(url) {
      if (this.isDragging) return
      this.showDialog = true
      this.videoUrl = url
    },
    startDrag(event) {
      // 重置状态
      if (this.timerId) clearTimeout(this.timerId)
      this.isDragging = false
      this.timerId = setTimeout(() => {
        this.isDragging = true
        // ...
      }, 100)
    },
    stopDrag() {
      if (this.timerId) clearTimeout(this.timerId)
      setTimeout(() => {
        this.isDragging = false
      }, 0)
      // ...
    }
  }
}
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
.careers {
  background-color: #fff;
  .title {
    font-family: 'Poppins', Sans-serif;
    color: #2a2c2f;
    font-size: 48px;
    font-weight: 600;
  }
  .label {
    color: #2a2b2f;
    font-size: 20px;
  }
  .head {
    position: relative;
    height: 550px;
    width: 100%;
    background-image: url('../../assets/careers/rotem-barak-813.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    &::before {
      display: block;
      width: 100%;
      height: 100%;
      content: '';
      background-color: transparent;
      background-image: linear-gradient(180deg, #ffffff 8%, #ffffffa3 100%);
    }
    div {
      position: absolute;
      top: 160px;
      left: 50%;
      transform: translateX(-50%);
      width: 880px;
      text-align: center;
      z-index: 20;
      font-family: 'Poppins', Sans-serif;
      .label {
        margin-top: 10px;
        margin-bottom: 30px;
      }
      .el-button {
        width: 200px;
        height: 65px;
        border-radius: 32px;
        background-color: #2f5ad9;
        border-color: #2f5ad9;
        font-size: 18px;
        font-weight: 600;
        border-width: 3px;
        transition: all 0.3s;
      }
      .el-button:hover {
        background-color: transparent;
        color: #2f5ad9;
      }
    }
  }
  .team {
    margin-top: 50px;
    padding: 30px 0;
    .title {
      text-align: center;
    }
    .label {
      text-align: center;
      width: 880px;
      margin: 15px auto 30px;
    }
    .swiper-slide {
      height: 372.6px;
      position: relative;
      .icon {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 75px;
        height: 75px;
        transform: translate(-50%, -50%);
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        -webkit-user-drag: none;
      }
    }
  }
  .open-position {
    background-image: url('../../assets/careers/Careers-Our-Open-Positions.jpg');
    background-position: 100% 90px;
    background-repeat: no-repeat;
    background-size: 50% auto;
    .inner {
      width: 1140px;
      margin: 100px auto;
      .title {
        text-align: left;
      }
      .list {
        margin-top: 130px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item {
          cursor: pointer;
          border-radius: 9px;
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
          padding: 0 20px 0 35px;
          display: flex;
          align-items: center;
          width: 350px;
          height: 100px;
          background-color: #fff;
          margin: 20px 0;
          opacity: 0.95;
          span {
            align-self: center;
            font-family: 'Poppins', Sans-serif;
            font-size: 26px;
            text-transform: uppercase;
            line-height: 1em;
          }
          transition: all 0.2s;
        }
        .item:hover {
          background-color: #2f5ad9;
          color: #fff;
        }
        .check-item {
          background-color: #2f5ad9;
          color: #fff;
        }
      }
    }
  }
  .photo-wall {
    .row {
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      .col {
        width: 33%;
        display: flex;
        flex-direction: column;
        p {
          flex: 1;
          padding: 20px 14px 0;
          font-size: 1.1vw;
          font-family: 'Arimo', Sans-serif;
          line-height: 1.4em;
          text-align: center;
          color: #2a2b2f;
          align-self: center;
        }
      }
      .col:nth-child(2) {
        width: 34%;
      }
      .col:nth-child(1) {
        margin-right: 15px;
      }
      .col:nth-child(3) {
        margin-left: 15px;
      }
    }
  }
  ::v-deep .el-dialog__wrapper {
    overflow: hidden;
    .el-dialog {
      height: 90vh !important;
      margin-top: 5vh !important;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
        width: 100%;
        height: 100%;
        iframe {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
